export interface ReviewIntervals {
    again: number;
    hard: number;
    good: number;
    easy: number;
}

function getGoodInterval(currentInterval: number) {
    if (currentInterval < 10)
        return 10;

    return currentInterval * 2;
}

function adjustRandomly(number: number) {
    const deltaPercents = 15;
    return number * (1 - deltaPercents / 100) + Math.random() * (number * deltaPercents * 2 / 100);
}

/** Next intervals (minutes) per rating, from the time actually passed since the last check. */
export function reviewIntervals(card: { interval: number; passedTime?: number }): ReviewIntervals {
    const actualInterval = card.passedTime ?? card.interval;
    const good = adjustRandomly(getGoodInterval(actualInterval));

    return {
        again: 1,
        hard: Math.floor(good / 4),
        good,
        easy: good * 2,
    };
}
